import React from 'react';
import { Route, Switch } from 'react-router-dom';
import TagHelpCenterView from '../TagHelpCenterView';

const TagHelpCenter = ({ match }) => {
  return (
    <Switch>
      <Route exact path={`${match.path}`} component={TagHelpCenterView} />
    </Switch>
  );
};

export default TagHelpCenter;
